'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.richMediaError = exports.richMediaReady = exports.richMediaEmbedding = exports.richMediaReturnToPreview = undefined;

var _richMediaConstants = require('./richMediaConstants');

var richMediaReturnToPreview = exports.richMediaReturnToPreview = function richMediaReturnToPreview(id) {
    return {
        id: id,
        type: _richMediaConstants.RICH_MEDIA_RETURN_TO_PREVIEW
    };
};

var richMediaEmbedding = exports.richMediaEmbedding = function richMediaEmbedding(id) {
    return {
        id: id,
        type: _richMediaConstants.RICH_MEDIA_EMBEDDING
    };
};

var richMediaReady = exports.richMediaReady = function richMediaReady(id) {
    return {
        id: id,
        type: _richMediaConstants.RICH_MEDIA_READY
    };
};

var richMediaError = exports.richMediaError = function richMediaError(id) {
    return {
        id: id,
        type: _richMediaConstants.RICH_MEDIA_ERROR
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/richMediaActions.js
// module id = 2019
// module chunks = 0